import*as o from"react";export const useLayoutEffect=Boolean(null===globalThis||void 0===globalThis?void 0:globalThis.document)?o.useLayoutEffect:()=>{};
//# sourceMappingURL=index.module.js.map
